angular.module('EdxReportCommonModule', []);